<template>
  <div class="">

  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: "FamilyTabbedContent.vue",
  computed: {
    ...mapGetters({
      family: '$_policy_page/family',
    }),
  }
}
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";
</style>